import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";
import { ChartService, IHighchartsDataSeries } from "@app/services/charts.service";
import { ColourService } from "@app/services/colour.service";
import { IBrakePerformanceScoreHistory } from "../_models/IBrakePerformanceScoreHistory";
import "./ebpms-score-history-graph.component.scss";

declare const Highcharts: any;

@Component({
    selector: 'ebpms-score-history-graph',
    template: require("./ebpms-score-history-graph.component.html")
})
export class EBPMSScoreHistoryGraphComponent implements OnChanges {
    @Input() history: IBrakePerformanceScoreHistory[];

    @ViewChild("chartContainer", { read: ElementRef }) chartContainer: ElementRef<HTMLElement>;

    constructor(private readonly chartService: ChartService, private readonly colourService: ColourService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.history) {
            return;
        }

        this.createChart();
    }

    // ---

    private createChart(): void {
        const chartConfig = this.chartService.createChartOptions("areaspline");

        chartConfig.chart.height = 150;
        chartConfig.chart.plotBorderWidth = 0;
        chartConfig.series = [this.createSeries()];

        (chartConfig.yAxis as Highcharts.AxisOptions).showFirstLabel = false;
        (chartConfig.yAxis as Highcharts.AxisOptions).min = 0;
        (chartConfig.yAxis as Highcharts.AxisOptions).max = 100;
        (chartConfig.yAxis as Highcharts.AxisOptions).minRange = 10;

        (chartConfig.xAxis as Highcharts.AxisOptions).startOnTick = false;
        (chartConfig.xAxis as Highcharts.AxisOptions).endOnTick = false;

        this.chartService.useVigetColours(chartConfig);

        this.createPlotBands(chartConfig);

        var chartObject = Highcharts.chart(this.chartContainer.nativeElement, chartConfig);
    }

    private createSeries(): IHighchartsDataSeries {
        const dataSeries: IHighchartsDataSeries<[number, number]> = {
            name: "BPV",
            data: []
        };

        dataSeries["pointIntervalUnit"] = "day";

        this.history.forEach(h => {
            if (h.Status == null || !h.Score) {
                return;
            }

            dataSeries.data.push([new Date(h.CalculatedTime).getTime(), h.Score]);
        });

        return dataSeries;
    }

    private createPlotBands(chartConfig: Highcharts.Options): void {
        const yaxis = chartConfig.yAxis as Highcharts.AxisOptions;

        yaxis.plotBands = yaxis.plotBands || [];
        yaxis.plotLines = yaxis.plotLines || [];

        yaxis.plotBands.push({
            from: 0,
            to: 45,
            id: "Warning",
            color: this.colourService.createTransparentColor(this.colourService.redColor, 0.18),
        });

        yaxis.plotLines.push({
            value: 45,
            color: this.colourService.createTransparentColor(this.colourService.redColor, 0.5),
            dashStyle: 'longdash',
            width: 1,
            zIndex: 3,
            label: {
                text: `BPV Threshold`,
                align: 'right',
                y: 15,
                x: -10,
                style: {
                    color: '#919191',
                    fontSize: "12",
                    fontWeight: "400"
                }
            }
        });
    }
}

